import { render, staticRenderFns } from "./contact_proprietaire.vue?vue&type=template&id=28e7b1fc"
import script from "./contact_proprietaire.js?vue&type=script&lang=js&external"
export * from "./contact_proprietaire.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports